import React from 'react';
import './ChartLegend.styles.scss';

function ChartLegend({data}) {
    return (
        <div className="chart-legend-wrap">
            <div className="chart-legend">
                {data.map((item, inx) => (
                    <div
                        key={inx}
                        className={`chart-legend__item chart-legend__item--${item.type}`}
                    >
                        <span
                            style={{
                                background: `${item.type === 'dotted' ? `none` : `${item.color}`}`,
                            }}
                        />
                        {item.name}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default ChartLegend;